import React from 'react';
import { motion } from 'framer-motion';
import { trackInitiateCheckout } from '../lib/pixel';
export function FinalCTA() {
  return <section className="py-24 bg-blue-600 relative overflow-hidden" data-id="element-74">
      {/* Decorative background pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
      backgroundSize: '24px 24px'
    }} data-id="element-75"></div>

      <div className="max-w-4xl mx-auto px-4 md:px-6 relative z-10 text-center" data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-77">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white tracking-tight mb-6 text-balance" data-id="element-78">
            Dejá de hacer anuncios genéricos para vender iPhones
          </h2>
          <p className="text-xl text-blue-100 mb-10 max-w-2xl mx-auto text-balance" data-id="element-79">
            Aprendé un sistema específico para crear campañas, mejorar tus
            conversaciones y vender con más criterio.
          </p>
          <a href="https://sistema-iphone-ads.myshopify.com/products/sistema-iphone-ads" onClick={trackInitiateCheckout} className="inline-flex items-center justify-center px-10 py-5 text-lg font-bold text-blue-600 bg-white rounded-full hover:bg-zinc-50 transition-colors shadow-xl hover:shadow-2xl hover:-translate-y-1 transform duration-200" data-id="element-80">
            Comprar guía ahora
          </a>
        </motion.div>
      </div>
    </section>;
}